import React, { useState } from "react";
import classes from "../customer.module.css";
import {
  TableCell,
  TableRow,
  Typography,
  Avatar,
  Chip,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import avatar from "../../../../Assets/images/avatar-9.jpg";
import { BsThreeDotsVertical } from "react-icons/bs";
import DonutChart from "../../Dashboard/DonutChart";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  activeEmployee,
  inactiveEmployee,
  removeTeamMember,
} from "../../../../Redux/actions/customerActions";
import { generateColor, stringAvatar, resolveFileUrl } from "../../../../Utilities/commonfunctions";
import CommonConformationmodal from "../../../../Components/CommonConformationmodal";

// Labels/colours for every signup_status getOneCustomerTeamDetails can
// return. Amber pair for the two in-progress states, green/red reused from
// the existing Active/Inactive chip, grey for deactivated.
const SIGNUP_STATUS_META = {
  invite_pending: { label: "Invite Pending", bg: "#FEF3D6", fg: "#9A6700" },
  registration_incomplete: {
    label: "Registration Incomplete",
    bg: "#FEF3D6",
    fg: "#9A6700",
  },
  registered: { label: "Registered", bg: "#E9F7EC", fg: "#317D41" },
  active: { label: "Active", bg: "#E9F7EC", fg: "#317D41" },
  deactivated: { label: "Deactivated", bg: "#EAEAEA", fg: "#616161" },
};

function TeamsListItem({ key, employee, team_id }) {
  const dispatch = useDispatch();
  const [openMenu, setOpenMenu] = useState();
  const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
  const { sortBy, invoice } = useSelector((state) => state.filter);

  // Invite-pending members have no Employee record yet (getOneCustomerTeamDetails
  // synthesizes their row from the team_members subdoc), so there is no
  // Employee _id for the active/inactive endpoints to act on.
  const hasEmployeeRecord = employee?.signup_status !== "invite_pending";
  const statusMeta =
    SIGNUP_STATUS_META[employee?.signup_status] ||
    (employee?.is_active
      ? SIGNUP_STATUS_META.active
      : SIGNUP_STATUS_META.deactivated);
  const teamChartData = [
    { name: "Rejected", value: Number(employee?.localFields?.rejected) || 0 },
    { name: "Pending", value: Number(employee?.localFields?.pending) || 0 },
    { name: "Reached", value: Number(employee?.localFields?.completed) || 0 },
  ];

  const handleMenuclick = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const handleClose = () => {
    setOpenMenu(null);
  }

  const handleEmployeeActive = (name) => {
    if (name === "active") {
      dispatch(activeEmployee(team_id, sortBy, invoice, employee?._id));
    }
    else if (name === "inactive") {
      dispatch(inactiveEmployee(team_id, sortBy, invoice, employee?._id));
    }
    handleClose();
  }

  const handleRemoveMember = () => {
    dispatch(
      removeTeamMember(
        team_id,
        employee?.team_member_id,
        sortBy,
        invoice,
        undefined,
        (message) =>
          alert(message || "Could not remove member. Please try again.")
      )
    );
  };

  return (
    <React.Fragment>
    <TableRow className={`${classes.table_bg1}`} key={key}>
      <TableCell>
        <div className={classes.displayFlex}>
          {employee?.user_id?.profile_pic && (employee?.user_id?.profile_pic?.filename || employee?.user_id?.profile_pic?.location) ?
            <Avatar
              alt="Remy Sharp"
              sx={{ width: 36 }}
              src={resolveFileUrl(employee?.user_id?.profile_pic?.location || `${employee?.user_id?.profile_pic?.destination}${employee?.user_id?.profile_pic?.filename}`)}
            />
            :
            <Avatar
              {...stringAvatar(`${employee?.name.trim()}`)}
              sx={{
                bgcolor: `${generateColor(`${employee?.name.trim()}`)}`,
              }}
              style={{ height: 36, width: 36, }}
            />
          }
          <Typography
            href="#javascript: void(0);"
            className="text-body align-middle fw-medium"
            style={{ textTransform: "capitalize" }}
          >
            {employee.name}
          </Typography>
        </div>
      </TableCell>
      <TableCell>{employee.phone}</TableCell>
      <TableCell>{moment(employee.created_at).format("DD MMM YYYY")}</TableCell>
      <TableCell>
        <div className={classes.displayFlex}>
          <DonutChart
            data={teamChartData}
            colors={["#BA1221", "#FBC23F", "#3A974C"]}
            size={56}
            thickness={0.5}
            centerValue={employee?.localFields?.total ?? 0}
            centerValueSize={15}
          />
          <div>
            <Typography className={classes.displayFlex}>
              <Avatar
                sx={{
                  bgcolor: `#3A974C`,
                  width: "6px",
                  height: "6px",
                }}
              >
                {" "}
              </Avatar>
              <span className={classes.someSmallText}>Reached:{employee?.localFields?.completed}</span>
            </Typography>
            <Typography className={classes.displayFlex}>
              <Avatar
                sx={{
                  bgcolor: `#FBC23F`,
                  width: "6px",
                  height: "6px",
                }}
              >
                {" "}
              </Avatar>
              <span className={classes.someSmallText}>Pending:{employee?.localFields?.pending}</span>
            </Typography>
            <Typography className={classes.displayFlex}>
              <Avatar
                sx={{
                  bgcolor: `#BA1221`,
                  width: "6px",
                  height: "6px",
                }}
              >
                {" "}
              </Avatar>
              <span className={classes.someSmallText}>Rejected:{employee?.localFields?.rejected}</span>
            </Typography>
          </div>
        </div>
      </TableCell>
      <TableCell>
        <span className="badge badge-soft-success p-2">
          {" "}
          <Chip
            label={statusMeta.label}
            size="small"
            style={{
              backgroundColor: statusMeta.bg,
              color: statusMeta.fg,
              padding: "10px",
            }}
          />
        </span>
      </TableCell>
      <TableCell style={{ minWidth: 0 }}>
        <Button
          variant="text"
          size="small"
          style={{ minWidth: 0 }}
          onClick={(e) => handleMenuclick(e)}
        >
          <BsThreeDotsVertical />
        </Button>
        <Menu
          anchorEl={openMenu}
          open={Boolean(openMenu)}
          onClose={handleClose}
          className={classes.InvoiceMenuOptions}
        >
          {hasEmployeeRecord && [
            <MenuItem
              key={`active`}
              onClick={() => handleEmployeeActive("active")}
            >
              Activate
            </MenuItem>,
            <MenuItem
              key={`inactive`}
              onClick={() => handleEmployeeActive("inactive")}
            >
              Deactivate
            </MenuItem>,
          ]}
          <MenuItem
            key={`remove`}
            onClick={() => {
              handleClose();
              setShowRemoveConfirm(true);
            }}
          >
            Remove from team
          </MenuItem>
        </Menu>
      </TableCell>
    </TableRow>
    {showRemoveConfirm && (
      <CommonConformationmodal
        type="delete"
        callback={handleRemoveMember}
        modalClose={() => setShowRemoveConfirm(false)}
      />
    )}
    </React.Fragment>
  );
}

export default TeamsListItem;
